<app-layout columnCount="2" vAlignment="middle">
  <app-layout-title>
    <app-go-back-button routerLink="/auth/login">
      {{ 'FORGOT.title' | translate }}
    </app-go-back-button>
  </app-layout-title>

  <app-layout-content>
    <form (submit)="sendRecovery()" [formGroup]="forgotForm" class="grid">
      <mat-form-field>
        <mat-label>{{ 'FORGOT.email_label' | translate }}</mat-label>
        <input #email="control"
          [placeholder]="'FORGOT.email_placeholder' | translate"
          formControlName="email"
          matInput
          type="email">
        @if (email.hasError('required')) {
          <mat-error>
            {{ 'VALIDATION.required' | translate }}
          </mat-error>
        }
        @if (email.hasError('email')) {
          <mat-error>
            {{ 'VALIDATION.email' | translate }}
          </mat-error>
        }
      </mat-form-field>
      <button color="primary" mat-raised-button type="submit">
        {{ 'FORGOT.send_mail' | translate }}
      </button>
    </form>
  </app-layout-content>
</app-layout>
